import React from 'react'
import './Header.css'
import SearchIcon from '@mui/icons-material/Search';
import HeaderOption from './HeaderOption';
import GiteIcon from '@mui/icons-material/Gite';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import BoltIcon from '@mui/icons-material/Bolt';
import { useDispatch } from 'react-redux';
import { logout } from './features/userSlice';
import { auth } from './firebase';

const Header = () => {
  const dispatch = useDispatch();
  const logoutOfApp = () => {
    dispatch(logout())
    auth.signOut();
  }
  return (
    <div className='header'>
        <div className='header__left'>
            <img src="https://cdn-icons-png.flaticon.com/512/8610/8610898.png" alt=""/>
            <div className='header__search'>
                <SearchIcon/>
                <input placeholder='Search' type="text"/>
            </div>
        </div>
        <div className='header__right'>
            <HeaderOption Icon={GiteIcon} title='Home'/>
            <HeaderOption Icon={Diversity3Icon} title='My network'/>
            <HeaderOption Icon={ReceiptLongIcon} title='Jobs'/>
            <HeaderOption Icon={QuickreplyIcon} title='Chats'/>
            <HeaderOption Icon={BoltIcon} title='Nudges'/>
            <HeaderOption avatar={true} title='me' onClick={logoutOfApp}/> 
        </div>
    </div>
  )
}

export default Header